import { createLogger, serializeError } from 'logging';
import { SubscriptionsApi } from 'subscription-service-client';
import { UserApi } from 'user-service-client';

import { User } from '@videoblocks/events-ts/lib/storyblocks/common/User';

export class CommonRecordFactory {
    private static logger = createLogger('CommonRecordFactory');

    public static async user(sessionToken: string | undefined, visitorCookieId: string | null): Promise<User> {
        const userEvent = new User();
        // make sure all fields are defaulted to null instead of undefined
        userEvent.visitorCookieId = visitorCookieId;
        userEvent.recurlySubscriptionId = null;
        userEvent.recurlySubscriptionUuid = null;
        userEvent.subscriptionId = null;
        userEvent.userId = null;
        userEvent.organizationId = null;
        userEvent.bot = null;

        try {
            if (sessionToken) {
                const user = await UserApi.getUserBySession(sessionToken);
                if (user) {
                    userEvent.userId = user.id ?? null;
                    userEvent.organizationId = user?.organizations?.[0]?.id ?? null;

                    const userSubscriptions = await SubscriptionsApi.getSubscriptionsByUserId(user.id);
                    const subscription = userSubscriptions[0];
                    if (subscription) {
                        if (subscription.isLegacy) {
                            const subscriptionId = parseInt(subscription.id, 10);
                            if (isNaN(subscriptionId)) {
                                this.logger.error(
                                    { subscriptionId: subscription.id },
                                    'Invalid subscription ID for legacy subscription type',
                                );
                            } else {
                                userEvent.subscriptionId = subscriptionId ?? null;
                            }
                        } else {
                            userEvent.recurlySubscriptionId = subscription.id ?? null;
                            userEvent.recurlySubscriptionUuid = subscription.uuid ?? null;
                        }
                    }
                }
            }
        } catch (error) {
            CommonRecordFactory.logger.error(
                { error: serializeError(error), sessionToken, visitorCookieId },
                'Error fetching user session information for new user event data',
            );
        }
        return userEvent;
    }
}
